import * as React from 'react';
import { Theme, UIText1 } from '@cian/ui-kit';
import * as style from './BuildersTooltip.css';
import { BuilderName } from '../BuilderName';
import { Link } from '../Link';
import { IBuilder } from '../../types/newbuilding';

export interface IBuildersTooltipProps {
  builders: IBuilder[];
  onBuilderClick?: () => void;
}

export const BuildersTooltip: React.FC<IBuildersTooltipProps> = props => {
  const { builders, onBuilderClick } = props;

  return (
    <Theme theme="light">
      <div className={style['tooltip-content']}>
        <UIText1>Комплекс строят несколько компаний:</UIText1>
        <div className={style['builders-list']}>
          {builders.map((builder, index) => (
            <Link key={`${builder}${index}`} url={builder.url} target="blank" onClick={onBuilderClick}>
              <BuilderName name={builder.name + (index < builders.length - 1 ? ', ' : '')} />
            </Link>
          ))}
        </div>
      </div>
    </Theme>
  );
};
